import { useState } from "react";
import { styled } from "@mui/material/styles";
import { Stack, Typography } from "@mui/material";
// components
import Page from "../../components/Page";
import { LoginForm } from "../../components/authentication/login";
import Logo from "src/components/Logo";

const RootStyle = styled(Page)(({ theme }) => ({
  paddingBottom: "0px",
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: "100%",
  margin: "auto",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
}));

// ----------------------------------------------------------------------
const TITLES = [
  "Welcome to Cribsfinder",
  "Confirm your number",
  "More Options",
  "Finish signing up",
];
export default function Login() {
  const [steps, setSteps] = useState(0);
  return (
    <RootStyle title="Login to Dashboard" sx={{ bgcolor: "primary.main" }}>
      <Stack
        alignItems="center"
        sx={{ width: 1, height: "100vh", overflow: "scroll", pb: 2 }}
      >
        <Stack
          alignItems="center"
          justifyContent="start"
          sx={{ width: 1, height: "fit-content", pt: 4 }}
        >
          <Logo isUseYellow sx={{ height: 70 }} />
        </Stack>
        <ContentStyle>
          <Stack
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{
              flexGrow: 1,
              flexShrink: 0,
              width: { md: "100%", xs: 1 },
              maxWidth: { md: "100%", xs: 1 },
              overflow: "hidden",
              overflowY: "scroll",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": {
                width: 0,
                height: 0,
              },
            }}
            spacing={4}
          >
            <Stack
              direction="column"
              sx={{ width: 1 }}
              alignItems="center"
              justifyContent="center"
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: "2rem",
                  fontWeight: 600,
                  width: 1,
                  textAlign: "center",
                  color: "common.white",
                  textShadow: {
                    md: "none",
                    xs: "1px 2px 4px rgba(0, 0, 0, 0.18)",
                  },
                }}
                gutterBottom
              >
                {TITLES[steps]}
              </Typography>
            </Stack>
            <LoginForm setSteps={setSteps} steps={steps} />
          </Stack>
        </ContentStyle>
      </Stack>
    </RootStyle>
  );
}
